/* @ngInject */
const myOwnerForm = (
  $$owner
) => {
  return {
    restrict: 'E',
    scope: {
      myOwner: '=',
      enableValidator: '=?',
    },
    template: require('./myOwnerForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$owner.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myOwnerForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/directives/form/myOwnerForm.js